/** Default tournament label — web, Android, and non–App Store surfaces. */
export const WC_BRAND_DEFAULT = {
  NAME: 'WC 2026',
  SHORT: 'WC',
  YEAR: '2026',
} as const;

/** App Store Guideline 5.2.1 — native iOS only. */
export const WC_BRAND_IOS_APP_STORE = {
  NAME: 'Football 2026',
  SHORT: 'Football',
  YEAR: '2026',
} as const;

export type WcBrand = {
  readonly NAME: string;
  readonly SHORT: string;
  readonly YEAR: string;
};
